import React, { useState } from "react";
import { Camera, Upload, User } from "lucide-react";
import "./PreinscripcionMobile.css";

/*
 * PreinscripcionMobile — the mobile screen a potential member lands on after
 * scanning the "QR de preinscripción" in the Socios section. Translated from
 * Figma (ClubAgent - UI, node 3452:27534, "Client's mobile view").
 *
 * This is the redesigned equivalent of the existing PreRegisterPage (route
 * /pre-register/:venueToken). Preview only: self-contained, mock submit. Scoped
 * under .pm-screen (no Tailwind in this CRA build — per-component CSS instead).
 */
export default function PreinscripcionMobile({ venueName = "Kong House Text", venuePhoto = null }) {
  const [photo, setPhoto] = useState(false);
  const [sent, setSent] = useState(false);
  const [f, setF] = useState({ nombre: "", apellidos: "", dni: "", nacimiento: "", telefono: "", email: "", direccion: "" });
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  if (sent) {
    return (
      <div className="pm-screen">
        <div className="pm-sent">
          <div className="pm-sent-check">✓</div>
          <h2 className="pm-sent-title">¡Solicitud enviada!</h2>
          <p className="pm-sent-text">Tu solicitud de preinscripción ha sido recibida por {venueName}. El club la revisará y se pondrá en contacto contigo.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pm-screen">
      <div className="pm-scroll">
        {/* venue header card */}
        <div className="pm-card pm-header">
          <div className="pm-venue">
            <div className="pm-venue-logo">{venuePhoto ? <img src={venuePhoto} alt={venueName} /> : <span className="pm-venue-fallback">42</span>}</div>
            <div className="pm-venue-meta">
              <div className="pm-venue-name">{venueName}</div>
              <div className="pm-venue-sub">Formulario de preinscripción de socio</div>
            </div>
          </div>
          <div className="pm-powered">Powered by <span className="pm-brand">ClubsAgent</span></div>
        </div>

        {/* form card */}
        <div className="pm-card pm-form">
          <div className="pm-photo-row">
            <div className="pm-photo-avatar">{photo ? <span className="pm-photo-filled" /> : <User size={30} />}</div>
            <div className="pm-photo-actions">
              <label className="pm-label">Foto del socio *</label>
              <button className="pm-btn-primary" onClick={() => setPhoto(true)}><Camera size={16} /> Hacer foto</button>
              <button className="pm-btn-outline"><Upload size={16} /> Subir foto</button>
              <span className="pm-help">Requerida para registrar el socio</span>
            </div>
          </div>

          <div className="pm-divider" />

          <div className="pm-field">
            <label className="pm-label pm-label--muted">Escanear DNI</label>
            <div className="pm-row2">
              <button className="pm-btn-outline">Anverso</button>
              <button className="pm-btn-outline">Reverso</button>
            </div>
          </div>

          <div className="pm-row2">
            <div className="pm-field"><label className="pm-label">Nombre *</label><input className="pm-input" value={f.nombre} onChange={set("nombre")} placeholder="Nombre" /></div>
            <div className="pm-field"><label className="pm-label">Apellidos *</label><input className="pm-input" value={f.apellidos} onChange={set("apellidos")} placeholder="Apellidos" /></div>
          </div>
          <div className="pm-row2">
            <div className="pm-field"><label className="pm-label">DNI</label><input className="pm-input" value={f.dni} onChange={set("dni")} placeholder="12345678K" /></div>
            <div className="pm-field"><label className="pm-label">Fecha nacimiento *</label><input className="pm-input" value={f.nacimiento} onChange={set("nacimiento")} placeholder="dd/mm/aaaa" /></div>
          </div>
          <div className="pm-field"><label className="pm-label">Teléfono</label><input className="pm-input" value={f.telefono} onChange={set("telefono")} placeholder="678890123" /></div>
          <div className="pm-field"><label className="pm-label">Email</label><input className="pm-input" value={f.email} onChange={set("email")} placeholder="email@email.com" /></div>
          <div className="pm-field"><label className="pm-label">Dirección</label><input className="pm-input" value={f.direccion} onChange={set("direccion")} placeholder="Calle, piso, etc" /></div>
        </div>
      </div>

      <div className="pm-submit-bar">
        <button className="pm-btn-primary pm-btn-block" onClick={() => setSent(true)}>Enviar solicitud</button>
      </div>
    </div>
  );
}
